<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="6" class="mb-md-0 mb-2">
          <label>{{ $t('User Manager') }}</label>
          <v-select multiple
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="managerFilter"
              :options="managersOptions"
              class="w-100"
              :reduce="val => val.id"
              label="name"
              @input="(val) => $emit('update:managerFilter', val)"
          />
        </b-col>

        <!-- <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{$t('User Contract')}}</label>
          <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="contractFilter"
              :options="contractsOptions"
              class="w-100"
              :reduce="val => val.id"
              label="name"
              @input="(val) => $emit('update:contractFilter', val)"
          />
        </b-col> -->



        <b-col cols="12" md="6" class="mb-md-0 mb-2">
          <label>{{$t('User Status')}}</label>
          <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="statusFilter"
              :options="statusOptions"
              class="w-100"
              :reduce="val => val.value"
              @input="(val) => $emit('update:statusFilter', val)"
          />
        </b-col>


      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {

    roleFilter: {
      type: [Number, null],
      default: null,
    },

    contractFilter: {
      type: [Number, null],
      default: null,
    },

    statusFilter: {
      type: [Number, null],
      default: null,
    },

    managerFilter: {
      type: Array,
      default: [],
    },

    contractsOptions: {
      type: Array,
      required: true,
    },

    managersOptions: {
      type: Array,
      required: true,
    },

    statusOptions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
